import http from '@services/http';
import { Users } from './interfaces';

export const refreshEmailVerification = (data: Users.RefreshEmailVerification.Request): Promise<Users.RefreshEmailVerification.Respose> => {
  return http.post(`/users/verify/emails/refresh`, data);
};

export const sendEmailVerification = (data: Users.SendEmailVerification.Request): Promise<Users.SendEmailVerification.Respose> => {
  return http.post(`/users/verify/emails/send`, data);
};